import React from "react";
import classNames from "classnames";

function FormInputText({
  input,
  meta,
  className,
  placeholder,
  disabled,
  readonly,
  onBlur,
  loading,
  type,
  shortValidation,
  maxLength
}) {
  return (
    <>
      <input
        type={type || "text"}
        {...input}
        placeholder={placeholder}
        className={classNames(`form-control ${className}`, {
          "is-invalid": meta.error && meta.touched && !readonly,
          "is-valid": !meta.error && meta.touched && meta.dirty && !readonly,
          "shortvalidation": shortValidation
        })}
        disabled={disabled}
        readOnly={readonly}
        maxLength={maxLength}

        onBlur={(e) => {
          input.onBlur(e);
          onBlur && onBlur(e);
        }}
      />
      {meta.touched && meta.error && !readonly &&!shortValidation && (
        <span
          className="form-error"
          role="alert"
          dangerouslySetInnerHTML={{ __html: meta.error }}
        ></span>
      )}
      {loading && <span className="form-control-loading"></span>}
    </>
  );
}

export default FormInputText;
